/**
 * @generated SignedSource<<ede66e60a894b1a13fb6fb5f62ee2e46>>
 * @relayHash b78a3d13d04f56d173c6257458e006c5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d6ffcaf3ec188b6d12846c50d9b0b45d04d314b7de466c91f3f29648c59a0a2a

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type FeedRecommendationsFeedRecDismissMutation$variables = {
  dismissTime: string;
};
export type FeedRecommendationsFeedRecDismissMutation$data = {
  readonly updateUserPreferences: {
    readonly feedRecommendedUserSettingsDismissTimestamp: string;
  } | null | undefined;
};
export type FeedRecommendationsFeedRecDismissMutation = {
  response: FeedRecommendationsFeedRecDismissMutation$data;
  variables: FeedRecommendationsFeedRecDismissMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "dismissTime"
  }
],
v1 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "feedRecommendedUserSettingsDismissTimestamp",
            "variableName": "dismissTime"
          }
        ],
        "kind": "ObjectValue",
        "name": "userPreferences"
      }
    ],
    "concreteType": "UserPreferences",
    "kind": "LinkedField",
    "name": "updateUserPreferences",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "feedRecommendedUserSettingsDismissTimestamp"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "FeedRecommendationsFeedRecDismissMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FeedRecommendationsFeedRecDismissMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b78a3d13d04f56d173c6257458e006c5",
    "id": "d6ffcaf3ec188b6d12846c50d9b0b45d04d314b7de466c91f3f29648c59a0a2a",
    "metadata": {},
    "name": "FeedRecommendationsFeedRecDismissMutation",
    "operationKind": "mutation",
    "text": "mutation FeedRecommendationsFeedRecDismissMutation($dismissTime:String!){updateUserPreferences(userPreferences:{feedRecommendedUserSettingsDismissTimestamp:$dismissTime}){feedRecommendedUserSettingsDismissTimestamp}}"
  }
};
})();

(node as any).hash = "a25c0690e1d844eea2512b1cc3580eb1";

export default node;
